import * as React from "react";
import { Form } from "react-bootstrap";

export default function SearchProductItem({ searchProduct, onChange, searchType }) {
  const handleChange = (e) => {
    onChange(e);
  };
  const getLabel = () => {
    let price = "+$" + searchProduct.price;
    if (searchProduct.price === 0) {
      price = "Included - Free";
    }
    price = " (" + price + ") ";
    searchProduct.popular ? (price += ' <span class="mp-label">Most Popular</span>') : "";
    searchProduct.recommended ? (price += ' <span class="r-label">Recommended</span>') : "";
    return searchProduct.customerName + price;
  };

  return (
    <div className={"search-product-item " + (searchType === searchProduct.code ? "selected" : "")} >
      <Form.Check
        inline
        label={
          <div className="primary-label" dangerouslySetInnerHTML={{ __html: getLabel() }}></div>
        }
        name="searchType"
        type="radio"
        value={searchProduct.code}
        checked={searchType === searchProduct.code}
        onChange={handleChange}
        id={searchProduct.code}
      />
      <p className="form-description">{searchProduct.desc}</p>
    </div>
  );
}
